export default __webpack_public_path__ + "a040538127cafd9e4f46ea89cbaf2349.png";